import { fixHtml } from '../../../utils/helpers';

export const sanitizeEmailValues = (values = {}) => {
    const safe = (value) => fixHtml(value ?? '');
    return {
        ...values,
        trainingHeader: safe(values.trainingHeader),
        trainingFooter: safe(values.trainingFooter),
        reminderTrainingHeader: safe(values.reminderTrainingHeader),
        reminderTrainingFooter: safe(values.reminderTrainingFooter),
        reminderAssessmentHeader: safe(values.reminderAssessmentHeader),
        reminderAssessmentFooter: safe(values.reminderAssessmentFooter),
        assessmentHeader: safe(values.assessmentHeader),
        assessmentFooter: safe(values.assessmentFooter),
        welcomeMessage: safe(values.welcomeMessage),
        training_subject: values.training_subject ?? '',
        reminder_training_subject: values.reminder_training_subject ?? '',
        reminder_assessment_subject: values.reminder_assessment_subject ?? '',
        assessment_subject: values.assessment_subject ?? '',
        training_greeting: values.training_greeting ?? '',
        reminder_training_greeting: values.reminder_training_greeting ?? '',
        reminder_assessment_greeting: values.reminder_assessment_greeting ?? '',
        assessment_greeting: values.assessment_greeting ?? '',
        mrkdwn_trainingHeader: safe(values.mrkdwn_trainingHeader),
        mrkdwn_trainingFooter: safe(values.mrkdwn_trainingFooter),
        mrkdwn_reminderTrainingHeader: safe(values.mrkdwn_reminderTrainingHeader),
        mrkdwn_reminderTrainingFooter: safe(values.mrkdwn_reminderTrainingFooter),
        mrkdwn_reminderAssessmentHeader: safe(values.mrkdwn_reminderAssessmentHeader),
        mrkdwn_reminderAssessmentFooter: safe(values.mrkdwn_reminderAssessmentFooter),
        mrkdwn_assessmentHeader: safe(values.mrkdwn_assessmentHeader),
        mrkdwn_assessmentFooter: safe(values.mrkdwn_assessmentFooter),
        mrkdwn_welcomeMessage: safe(values.mrkdwn_welcomeMessage),
    };
};

export const copyToClipboard = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).catch(() => {
            fallbackCopyToClipboard(text);
        });
    } else {
        fallbackCopyToClipboard(text);
    }
};

const fallbackCopyToClipboard = (text) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    try {
        document.execCommand('copy');
    } catch (err) {
        // Ignore
    }
    document.body.removeChild(textArea);
};

export const getTabIdForWelcomeMessage = (trainingEnabled, assessmentEnabled) => {
    if (trainingEnabled && assessmentEnabled) return '5';
    if (trainingEnabled) return '3';
    if (assessmentEnabled) return '3';
    return '1';
};

export const getActiveTabId = (tabType, trainingEnabled, assessmentEnabled) => {
    const tabIds = {
        training: '1',
        trainingReminder: '2',
        assessment: trainingEnabled ? '3' : '1',
        assessmentReminder: trainingEnabled ? '4' : '2',
        welcome: getTabIdForWelcomeMessage(trainingEnabled, assessmentEnabled),
    };
    return tabIds[tabType] || '1';
};

